import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@/shared/styles/blank.scss';
import '@/shared/styles/variables.scss';
import '@/shared/styles/main.scss';
import '@/shared/styles/animations.scss';
import '@/shared/styles/fonts.scss';

const ChangeSalaryRates = lazy(() => import('@/pages/ChangeSalaryRate/index'));
const UpdateTaskChangeLog = lazy(() => import('@/pages/UpdateTaskChangeLog/index'));
const AddProjectBudget = lazy(() => import('@/pages/AddProjectBudget/index'));

// 1. Создаем Data Router через массив объектов
const router = createBrowserRouter([
    {
        path: "/change-empl-rates",
        element: <ChangeSalaryRates />,
    },
    {
        path: "/add-project-budget",
        element: <AddProjectBudget />,
    },
    {
        path: "/update-task-changelog",
        element: <UpdateTaskChangeLog />,
    },
]);

function AppRouter() {
    return (
        <Suspense fallback={null}>
            {/* 2. Подключаем созданный роутер */}
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default AppRouter;
